// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LanguageProvider } from './i18n/LanguageContext';
import { getSpanishAliasBasename } from './utils/spanishMarket';

// Import BrowserRouter (for React Router v5)
import { BrowserRouter as Router } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
const routerBasename = getSpanishAliasBasename();
root.render(
  <React.StrictMode>
    {/* Wrap the App with Router */}
    <Router basename={routerBasename}>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </Router>
  </React.StrictMode>
);

reportWebVitals();
